"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFutureTradeParams = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const useFeeRate_1 = require("../../../hooks/useFeeRate");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const LiquidationCalculator_1 = require("../../Calculator/LiquidationCalculator");
const LeverageConfig_1 = require("../../FuturesConfig/FutureLeverageProvider/LeverageConfig");
const CustomAssetsProvider_1 = require("./../../../component/Assets/CustomAssetsProvider");
const const_1 = require("./../../../component/const");
const FuturesCurIndexContext_1 = require("./../../../context/FuturesCurIndexContext");
const CalculateUtils_1 = require("./CalculateUtils");
const CheckFutureRequest_1 = require("./CheckFutureRequest");
const TradeValidate_1 = require("./TradeValidate");
function getTradeErrorInfo(symbolInfo, 
/** 用户输入的投资额 */
curQty, 
/** 投资偏好类型, 未转换 */
investSide, 
/** 杠杆倍数 */
leverage, esNotional, limits) {
    const { maxTradeLimit, tradeCanBuy, maxNotionLimit } = limits;
    const isBase = investSide === interface_1.InvestSymbolSide.base;
    if (curQty.gt(tradeCanBuy)) {
        const val = trade_utils_lib_1.NumberFormatter.format(limits.tradeCanBuyDisplay, {
            locale: (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocale(),
            precision: "default",
        });
        return (0, errors_1.cloneError)(isBase ? errors_1.TRADE_FUTURES_AVAILABLE_NOT_ENOUGH_BY_BASE : errors_1.TRADE_FUTURES_AVAILABLE_NOT_ENOUGH_BY_QUOTE, {
            max: `${val} ${isBase ? symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay : symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
        });
    }
    if (curQty.gt(maxTradeLimit)) {
        const val = trade_utils_lib_1.NumberFormatter.format(limits.maxTradeLimitDisplay, {
            locale: (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocale(),
            precision: "default",
        });
        return (0, errors_1.cloneError)(isBase ? errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_BASE : errors_1.TRADE_QTY_HIGH_THAN_MAX_BY_QUOTE, {
            max: `${val} ${isBase ? symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay : symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
        });
    }
    try {
        (0, CheckFutureRequest_1.verifyEsNotionalGtMaxEs)({
            esNotional: esNotional,
            notionalLimit: maxNotionLimit,
            investSide,
        });
    }
    catch (error) {
        return error;
    }
    return undefined;
}
const useFutureTradeParams = (props) => {
    var _a, _b;
    const { symbolInfo, marginType, orderSide, orderTypeUI, reduceOnly, postOnly, leverage, investSide: originInvestSide, price: limitPrice, qty, curPrice: latestPrice, isFocused, triggerPrice, releaseOrderMargin, positionMode, ratio, disableCheckLimitPrice, } = props;
    /** 投资数量的精度 */
    let investPrecision = 0;
    const investSide = originInvestSide === interface_1.InvestSymbolSide.cost ? interface_1.InvestSymbolSide.quote : originInvestSide;
    // 实际订单类型
    let orderType = interface_1.CustomOrderType.UNKNOWN;
    if (orderTypeUI === interface_1.FuturesOrderTypeUI.limit) {
        if (postOnly) {
            // 只有限价单有仅挂单
            orderType = interface_1.CustomOrderType.POST;
        }
        else {
            orderType = interface_1.CustomOrderType.LIMIT;
        }
        if (investSide === interface_1.InvestSymbolSide.base) {
            investPrecision = symbolInfo.amount || 0;
        }
        else {
            investPrecision = symbolInfo.precisionCost || 0;
        }
    }
    else if (orderTypeUI === interface_1.FuturesOrderTypeUI.market) {
        if (investSide === interface_1.InvestSymbolSide.base) {
            orderType = interface_1.CustomOrderType.MARKET_QTY;
            investPrecision = symbolInfo.amount || 0;
        }
        else {
            orderType = interface_1.CustomOrderType.MARKET_AMT;
            investPrecision = symbolInfo.precisionCost || 0;
        }
    }
    // 如果是按本金下单，则转换为按quote下单的值。
    const investQty = (() => {
        // 当按照cost本金下单时，需要将cost转换成quote
        if (originInvestSide === interface_1.InvestSymbolSide.cost) {
            return new trade_utils_lib_1.SafeDecimal(qty).mul(leverage).toFixed(investPrecision);
        }
        // 转为string
        return qty + "";
    })();
    // 是否是市价单
    const isMarketOrder = CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType);
    const asset = (0, CustomAssetsProvider_1.useCustomAssets)(const_1.FutureAccountType, isFocused);
    const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(positionMode, reduceOnly, orderSide);
    const balanceInfo = (0, CustomAssetsProvider_1.useFuturesAvailable)(symbolInfo.quote, isFocused);
    const { position, rPosition, hadPositions } = (0, react_1.useMemo)(() => {
        var _a, _b;
        const allPositions = (asset === null || asset === void 0 ? void 0 : asset.positionMap.get(symbolInfo.symbol)) || [];
        let _position;
        let _rPosition;
        if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
            _position = allPositions[0];
        }
        else {
            // 获取当前仓位跟反向仓位
            _position = allPositions.find((it) => it.position_side === positionSide);
            const reverseSide = positionSide === interface_1.FuturePositionSide.LONG ? interface_1.FuturePositionSide.SHORT : interface_1.FuturePositionSide.LONG;
            _rPosition = allPositions.find((it) => it.position_side === reverseSide);
        }
        let _hadPositions = ((_b = (_a = asset === null || asset === void 0 ? void 0 : asset.positions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        return { position: _position, hadPositions: _hadPositions, rPosition: _rPosition };
    }, [asset, positionMode, positionSide, symbolInfo]);
    // 可用保证金
    // 2023/1/31  去掉该处的精度处理，由ui层进行截断（原因：如果在此处按照quote的进度进行截断可能会导致精度丢失）
    // 最小值为0
    const available = (_a = balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.available) !== null && _a !== void 0 ? _a : "";
    const feeRate = (0, useFeeRate_1.useFeeRate)(symbolInfo.base, symbolInfo.quote);
    // 当前的标记价格
    const futuresIndex = (0, FuturesCurIndexContext_1.useFuturesIndexParseContext)({
        base: symbolInfo.base,
        quote: symbolInfo.quote,
        isFocused: isFocused && !triggerPrice,
    });
    const curMarkPrice = futuresIndex === null || futuresIndex === void 0 ? void 0 : futuresIndex.mark_price;
    // 当前价格
    const curPrice = triggerPrice ? triggerPrice : latestPrice;
    // 标记价格
    const markPrice = triggerPrice ? triggerPrice : curMarkPrice;
    // 获取杠杆倍数信息
    const { curLeverageRow, leverageConfig } = (0, LeverageConfig_1.useLeverageConfigRow)(symbolInfo.symbol, leverage);
    /**下单时使用最新的价格 */
    const [tradePriceD] = (0, react_1.useMemo)(() => {
        const _price = new trade_utils_lib_1.SafeDecimal(limitPrice);
        const _cur = new trade_utils_lib_1.SafeDecimal(curPrice);
        const _tradeP = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? _price : _cur;
        return [_tradeP];
    }, [curPrice, orderType, limitPrice]);
    /**成交均价用来计算单笔最大可开，以及当前资产下最大可开的量 */
    const tradeAvgPriceD = (() => {
        if (triggerPrice) {
            // 优先用户输入的限价，然后是触发价格
            return new trade_utils_lib_1.SafeDecimal(limitPrice || triggerPrice);
        }
        if (isMarketOrder) {
            return TradeValidate_1.TradeValidator.getAvgMarketPrice(symbolInfo, curMarkPrice, orderSide, reduceOnly);
        }
        return new trade_utils_lib_1.SafeDecimal(limitPrice);
    })();
    /**预估标记价格，用来计算最大名义价值可开 */
    const esMarkPriceD = (() => {
        if (triggerPrice) {
            // TODO: 待优化
            // 优先用户输入的限价，然后是触发价格
            return new trade_utils_lib_1.SafeDecimal(limitPrice || triggerPrice);
        }
        if (isMarketOrder) {
            return new trade_utils_lib_1.SafeDecimal(curMarkPrice);
        }
        return new trade_utils_lib_1.SafeDecimal(limitPrice);
    })();
    // 基于base的投资额，investSide为base就是数值本身，为quote时转换成base
    const baseInvest = (0, react_1.useMemo)(() => {
        var _a;
        if (investSide === interface_1.InvestSymbolSide.base) {
            return investQty;
        }
        else {
            // 当交易价格为0时，这时候计算 base 量无意义，投资额直接返回0
            if (tradePriceD.isZero()) {
                return "0";
            }
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(investQty).div(tradePriceD), (_a = symbolInfo.amount) !== null && _a !== void 0 ? _a : 0, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
        }
    }, [investSide, investQty, symbolInfo.amount, tradePriceD]);
    // 计算基于 quote 的投资额
    const quoteInvest = (0, react_1.useMemo)(() => {
        if (investSide === interface_1.InvestSymbolSide.base) {
            return new trade_utils_lib_1.SafeDecimal(baseInvest).mul(tradePriceD).toFixed();
        }
        else {
            // 投 quote 时，直接使用investQty，如果用和投 base 一样的算法，则会有精度丢失，因为在计算baseInvest时，处理了精度
            return investQty;
        }
    }, [baseInvest, investQty, investSide, tradePriceD]);
    // 反向持仓量， 反向仓位的未实现盈亏
    const [reversePosition, enableReduce] = (0, react_1.useMemo)(() => {
        let rP = new trade_utils_lib_1.SafeDecimal(0);
        // 双向仓位开仓时不考虑反向仓位，只有在平仓时需要考虑反向仓位
        if (positionMode === interface_1.OrderPositionMode.OPENCLOSE) {
            if (!reduceOnly) {
                return [rP, false];
            }
        }
        const positionQty = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionQuantity);
        if (orderSide === interface_1.CustomOrderSide.BUY) {
            if (positionQty.lessThan(0)) {
                rP = positionQty;
            }
        }
        else {
            if (positionQty.greaterThan(0)) {
                rP = positionQty;
            }
        }
        const _enableReduce = !rP.equals(0);
        return [rP, _enableReduce];
    }, [positionMode, position === null || position === void 0 ? void 0 : position.positionQuantity, orderSide, reduceOnly]);
    // 预估交易后的仓位价值
    // 获取当前档位下最多可投base或者quote
    const [esNotional, maxInvest] = CalculateUtils_1.CalculateUtils.getEstNotional({
        invest: investQty,
        positionQty: position === null || position === void 0 ? void 0 : position.positionQuantity,
        reversePositionQty: rPosition === null || rPosition === void 0 ? void 0 : rPosition.positionQuantity,
        orderSide,
        reduceOnly,
        positionMode,
        precision: (_b = symbolInfo.precision) !== null && _b !== void 0 ? _b : 0,
        amountPrecision: symbolInfo.amount,
        leverageRow: curLeverageRow,
        marginType,
        markPrice: new trade_utils_lib_1.SafeDecimal(markPrice),
        esMarkPrice: esMarkPriceD,
        investSide,
        avgMarkPrice: tradeAvgPriceD,
        isLimitOrder: orderTypeUI === interface_1.FuturesOrderTypeUI.limit,
    });
    // 根据当前symbol的配置获取单笔交易允许的最大值
    // 该值已经根据base/quote进行了转化
    const maxTradeLimit = (() => {
        if (tradeAvgPriceD.eq(0) || !symbolInfo) {
            return new trade_utils_lib_1.SafeDecimal(Number.MAX_VALUE);
        }
        const avgPrice = tradeAvgPriceD.toString();
        if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
            const [, maxQty] = TradeValidate_1.TradeValidator.getLimitQtyRange(symbolInfo, avgPrice, reduceOnly);
            if (investSide === interface_1.InvestSymbolSide.quote) {
                return maxQty.mul(tradeAvgPriceD);
            }
            return maxQty;
        }
        else if (CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType)) {
            const [, maxQty] = TradeValidate_1.TradeValidator.getMarketQtyRange(symbolInfo, avgPrice, reduceOnly);
            const [, maxSpending] = TradeValidate_1.TradeValidator.getMarketSpendingNotionRange(symbolInfo);
            // 若为市价，考虑价格波动缓冲：最大下单量 = 最大下单量 * 0.98
            if (investSide === interface_1.InvestSymbolSide.base) {
                return trade_utils_lib_1.SafeDecimal.min(maxQty, maxSpending.div(tradeAvgPriceD)).mul(0.98);
            }
            else {
                return trade_utils_lib_1.SafeDecimal.min(maxQty.mul(tradeAvgPriceD), maxSpending).mul(0.98);
            }
        }
        return new trade_utils_lib_1.SafeDecimal(Number.MAX_VALUE);
    })();
    const [canBuy, canBuyDisplay, errorInfo] = (() => {
        const leverD = new trade_utils_lib_1.SafeDecimal(leverage);
        /** 反向仓位绝对值，需要加上未实现盈亏 */
        const reversePositionABS = reversePosition.abs();
        /** 可买卖数量 */
        let cb = "";
        let cbDisplay = "";
        /** 可用保证金，再有仓位时因为会有占用保证金的波动会导致可用不足，取 0.98 的冗余 */
        const availMarinD = new trade_utils_lib_1.SafeDecimal(new trade_utils_lib_1.SafeDecimal(balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.availableMargin).mul(hadPositions ? 0.98 : 1).toFixed(symbolInfo.precisionCost));
        /** 修改订单时，需要加上当前订单占用的保证金 */
        const tradedMargin = availMarinD.add(new trade_utils_lib_1.SafeDecimal(releaseOrderMargin));
        /** 平仓后的保证金可投金额： 保证金 * 杠杆倍数，最小值为 0 */
        const availInvestD = trade_utils_lib_1.SafeDecimal.max(tradedMargin.mul(leverD), 0);
        /** 反向仓位可投的quote， 用当前最新的标记价格去计算*/
        const positionCanCost = reversePositionABS.mul(new trade_utils_lib_1.SafeDecimal(curMarkPrice));
        /** 保证金可买的 base 数量 */
        const marginCB = trade_utils_lib_1.SafeDecimal.min(availInvestD.div(tradeAvgPriceD), availInvestD.div(esMarkPriceD));
        /** 当前杠杆下最大可投的base或者quote的额 */
        const maxInvestD = new trade_utils_lib_1.SafeDecimal(maxInvest).abs();
        /**用户投入的下单量(base/quote) */
        const userInvest = new trade_utils_lib_1.SafeDecimal(investQty);
        /** 最大名义价值限制 */
        const notionalLimit = new trade_utils_lib_1.SafeDecimal(curLeverageRow === null || curLeverageRow === void 0 ? void 0 : curLeverageRow.notional_limit);
        let errorInfo;
        if (reduceOnly) {
            if (investSide === interface_1.InvestSymbolSide.base) {
                if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
                    cb = "";
                }
                else {
                    cb = reversePositionABS.eq(0) ? "0" : "";
                }
                cbDisplay = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(reversePositionABS, investPrecision);
            }
            else {
                cbDisplay = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(positionCanCost, investPrecision);
                if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
                    cb = "";
                }
                else {
                    cb = new trade_utils_lib_1.SafeDecimal(cbDisplay).eq(0) ? "0" : "";
                }
            }
        }
        else if (!tradeAvgPriceD.equals(0)) {
            if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
                // 按数量下单
                if (investSide === interface_1.InvestSymbolSide.base) {
                    // 保证金可买 + 反向持仓量
                    const tradeCanBuy = marginCB.add(reversePositionABS);
                    const realCanBuy = trade_utils_lib_1.SafeDecimal.min(maxTradeLimit, tradeCanBuy, maxInvestD);
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(realCanBuy, investPrecision);
                    cbDisplay = cb;
                    errorInfo = getTradeErrorInfo(symbolInfo, userInvest, originInvestSide, leverage, esNotional, {
                        maxTradeLimit,
                        maxTradeLimitDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(maxTradeLimit, investPrecision),
                        tradeCanBuy,
                        tradeCanBuyDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(tradeCanBuy, investPrecision),
                        maxNotionLimit: notionalLimit,
                    });
                }
                else {
                    // 可投 反向持仓价值 + 乘以杠杆倍数的可投金额
                    const tradeCanBuy = positionCanCost.add(availInvestD);
                    const realCanBuy = trade_utils_lib_1.SafeDecimal.min(maxTradeLimit, tradeCanBuy, maxInvestD);
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(realCanBuy, investPrecision);
                    cbDisplay = cb;
                    errorInfo = getTradeErrorInfo(symbolInfo, userInvest, originInvestSide, leverage, esNotional, {
                        maxTradeLimit,
                        maxTradeLimitDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(originInvestSide === interface_1.InvestSymbolSide.cost ? maxTradeLimit.div(leverD) : maxTradeLimit, investPrecision),
                        tradeCanBuy,
                        tradeCanBuyDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(originInvestSide === interface_1.InvestSymbolSide.cost ? tradeCanBuy.div(leverD) : tradeCanBuy, investPrecision),
                        maxNotionLimit: notionalLimit,
                    });
                }
            }
            else if (CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType)) {
                /** 市价单保证金冗余 */
                const marketMarginOffset = 0.95;
                // 按数量下单
                if (investSide === interface_1.InvestSymbolSide.base) {
                    const tradeCanBuy = marginCB.mul(marketMarginOffset).add(reversePositionABS);
                    const realCanBuy = trade_utils_lib_1.SafeDecimal.min(maxTradeLimit, tradeCanBuy, maxInvestD);
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(realCanBuy, investPrecision);
                    // 保证金可买 * 冗余 + 反向持仓量
                    cbDisplay = cb;
                    errorInfo = getTradeErrorInfo(symbolInfo, userInvest, originInvestSide, leverage, esNotional, {
                        maxTradeLimit,
                        maxTradeLimitDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(maxTradeLimit, investPrecision),
                        tradeCanBuy,
                        tradeCanBuyDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(tradeCanBuy, investPrecision),
                        maxNotionLimit: notionalLimit,
                    });
                }
                else {
                    const tradeCanBuy = availInvestD.mul(marketMarginOffset).add(positionCanCost);
                    const realCanBuy = trade_utils_lib_1.SafeDecimal.min(maxTradeLimit, tradeCanBuy, maxInvestD);
                    // 反向持仓价值 + 可投金额
                    cb = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(realCanBuy, investPrecision);
                    // 反向持仓价值 * 冗余 + 可投金额
                    cbDisplay = cb;
                    errorInfo = getTradeErrorInfo(symbolInfo, userInvest, originInvestSide, leverage, esNotional, {
                        maxTradeLimit,
                        maxTradeLimitDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(originInvestSide === interface_1.InvestSymbolSide.cost ? maxTradeLimit.div(leverD) : maxTradeLimit, investPrecision),
                        tradeCanBuy,
                        tradeCanBuyDisplay: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(originInvestSide === interface_1.InvestSymbolSide.cost ? tradeCanBuy.div(leverD) : tradeCanBuy, investPrecision),
                        maxNotionLimit: notionalLimit,
                    });
                }
            }
        }
        return [cb, cbDisplay, errorInfo];
    })();
    // 开仓所需保证金
    const marginNeed = (0, react_1.useMemo)(() => {
        // 仅减仓时所需保证金为0
        if (reduceOnly) {
            return "0";
        }
        if (!investQty || tradePriceD.equals(0)) {
            return "";
        }
        const leverageD = new trade_utils_lib_1.SafeDecimal(leverage);
        if (investSide === interface_1.InvestSymbolSide.base) {
            return new trade_utils_lib_1.SafeDecimal(investQty).mul(tradePriceD).div(leverageD).toString();
        }
        else {
            return new trade_utils_lib_1.SafeDecimal(investQty).div(leverageD).toString();
        }
    }, [reduceOnly, investQty, tradePriceD, leverage, investSide]);
    const isQuoteRatioOnReduceOnly = ratio && reduceOnly && investSide !== interface_1.InvestSymbolSide.base;
    const getInvestQty = () => {
        if (isQuoteRatioOnReduceOnly) {
            const ratioD = new trade_utils_lib_1.SafeDecimal(ratio);
            const rounding = reduceOnly ? trade_utils_lib_1.SafeDecimal.ROUND_CEIL : trade_utils_lib_1.SafeDecimal.ROUND_FLOOR;
            return new trade_utils_lib_1.SafeDecimal(canBuyDisplay).mul(ratioD).div(100).toDP(investPrecision, rounding).toString();
        }
        return investQty;
    };
    const getBaseInvest = () => {
        var _a;
        if (isQuoteRatioOnReduceOnly) {
            // FIX 限价单/市价单拉满不能全平的问题
            // 如果滑动输入条的值为100，直接取仓位的 base 量，否则按照用户输入的值
            const ratioD = new trade_utils_lib_1.SafeDecimal(ratio);
            if (ratioD.eq(100)) {
                return reversePosition
                    .abs()
                    .toDP((_a = symbolInfo.amount) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                    .toString();
            }
        }
        return baseInvest;
    };
    const lastBaseInvest = getBaseInvest();
    // 计算最终的 quote 投资额，平仓时，投 quote 并且滑动输入条输入为100%时，直接取反向仓位计算
    const getQuoteInvest = () => {
        if (isQuoteRatioOnReduceOnly) {
            const ratioD = new trade_utils_lib_1.SafeDecimal(ratio);
            if (ratioD.eq(100)) {
                return new trade_utils_lib_1.SafeDecimal(lastBaseInvest).mul(tradePriceD).toString();
            }
        }
        return quoteInvest;
    };
    /**生成下单时的参数 */
    const tradeParams = {
        accountType: const_1.FutureAccountType,
        symbol: symbolInfo,
        marginType: marginType,
        leverage: leverage,
        orderType: orderType,
        side: orderSide,
        investSide: investSide,
        originInvestSide,
        available: available,
        canBuy: canBuy,
        price: limitPrice,
        // 市价单需要使用缩放后的价格进行下单
        curPrice: isMarketOrder ? tradeAvgPriceD.toString() : curPrice,
        markPrice: markPrice,
        amount: getInvestQty(),
        baseInvest: lastBaseInvest,
        quoteInvest: getQuoteInvest(),
        postOnly: postOnly,
        reduceOnly: reduceOnly,
        esNotional: esNotional,
        leverageConfigRow: curLeverageRow,
        positionMode: positionMode,
        disableCheckLimitPrice,
    };
    const createOrder = () => (0, CheckFutureRequest_1.createFutureOrder)(tradeParams, errorInfo);
    const verifyCanTrade = () => (0, CheckFutureRequest_1.verifyFuturesOrder)(tradeParams, errorInfo);
    const baseConformParams = {
        symbolInfo,
        orderType,
        orderSide,
        postOnly,
        investSide,
        price: limitPrice,
        curPrice,
        available,
        qty: investQty,
        reduceOnly,
        marginType,
        leverage: String(leverage),
    };
    /**计算逐仓模式下的可用保证金 */
    const isolateAvailable = marginType === interface_1.FutureMarginType.CROSS ? "" : new trade_utils_lib_1.SafeDecimal(baseInvest).mul(tradePriceD).div(new trade_utils_lib_1.SafeDecimal(leverage)).toString();
    const [esLiquidationPrice, originalEsLiquidationPrice] = (() => {
        var _a;
        if (reduceOnly) {
            return [];
        }
        const isMakerOrder = postOnly;
        const avail = isolateAvailable || baseConformParams.available;
        /** 预估交易量 */
        const esVolume = new trade_utils_lib_1.SafeDecimal(baseInvest).mul(tradePriceD);
        const fee = esVolume.mul(isMakerOrder ? new trade_utils_lib_1.SafeDecimal(feeRate.makerFeeRate) : new trade_utils_lib_1.SafeDecimal(feeRate.takerFeeRate));
        const _estLiqPrice = LiquidationCalculator_1.LiquidationCalculator.calcuLiquidationPrice({
            leverageConfigs: (leverageConfig === null || leverageConfig === void 0 ? void 0 : leverageConfig.rows) || [],
            position: baseInvest,
            avgPrice: tradePriceD,
            side: orderSide === interface_1.CustomOrderSide.BUY ? "long" : "short",
            assets: avail,
            otherSpending: fee,
        });
        const rounding = positionSide === interface_1.FuturePositionSide.SHORT ? trade_utils_lib_1.SafeDecimal.ROUND_FLOOR : trade_utils_lib_1.SafeDecimal.ROUND_CEIL;
        const originalTradePrice = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? limitPrice : curPrice;
        return [
            // NOTE: 使用 toFixed 避免预估强平价被显示成科学计数法
            _estLiqPrice.eq(0) ? "" : _estLiqPrice.toFixed((_a = symbolInfo.precision) !== null && _a !== void 0 ? _a : 2, rounding),
            originalTradePrice && qty ? _estLiqPrice.toString() : "",
        ];
    })();
    /**下单二次校验的参数 */
    const tradeConformParams = (() => {
        /** 交易后仓位是怎么变更的 */
        const baseQty = new trade_utils_lib_1.SafeDecimal(baseInvest).mul(orderSide === interface_1.CustomOrderSide.BUY ? 1 : -1).toString();
        const positionSideChanged = CalculateUtils_1.CalculateUtils.getPositionChanged(baseQty, reduceOnly, position);
        // 生成下单二次确认弹窗需要的参数
        return Object.assign(Object.assign({}, baseConformParams), { symbolInfo: symbolInfo, estLiqPrice: esLiquidationPrice || "", sideChanged: positionSideChanged, leverage,
            positionSide });
    })();
    /**平仓时，qty 是否大于仓位可平数量 */
    const isCloseQtyGtPositionQty = (0, react_1.useMemo)(() => {
        if (reduceOnly && enableReduce) {
            let positionCanBuy = reversePosition.abs();
            if (originInvestSide !== interface_1.InvestSymbolSide.base) {
                /** 反向仓位可投的quote， 用当前最新的标记价格去计算*/
                positionCanBuy = positionCanBuy.mul(new trade_utils_lib_1.SafeDecimal(curMarkPrice));
                if (originInvestSide === interface_1.InvestSymbolSide.cost) {
                    positionCanBuy = positionCanBuy.div(leverage);
                }
            }
            if (new trade_utils_lib_1.SafeDecimal(qty).abs().greaterThan(positionCanBuy)) {
                return true;
            }
        }
        return false;
    }, [curMarkPrice, enableReduce, leverage, originInvestSide, qty, reduceOnly, reversePosition]);
    const verifyLimitPriceImpact = (0, common_business_1.usePersistFn)(() => {
        return (0, rxjs_1.of)(true).pipe((0, operators_1.tap)(() => {
            (0, CheckFutureRequest_1.checkLimitPriceImpact)(tradeParams);
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
        }));
    });
    return {
        position: position,
        available: available,
        availableMargin: (balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.availableMargin) || "",
        canBuy: canBuy,
        canBuyDisplay: canBuyDisplay,
        marginNeed: marginNeed,
        createOrder: createOrder,
        enableReduceOnly: enableReduce,
        estLiqPrice: esLiquidationPrice,
        originalEstLiqPrice: originalEsLiquidationPrice,
        verifyCanTrade,
        tradeConformParams,
        tradeParams,
        investQty,
        errorInfo,
        futuresIndex: futuresIndex,
        isCloseQtyGtPositionQty,
        verifyLimitPriceImpact,
    };
};
exports.useFutureTradeParams = useFutureTradeParams;
